<template>
    <el-container style="height: 100%" class="sale">
        <el-header style="height: 30px">
            <van-nav-bar title="新增仪器销售" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main style="height: 100%">
            <el-form :inline="true" :model="searchParms">
                <el-form-item label="品牌门店">
                    <el-cascader :options="storeData" clearable filterable v-model="searchParms.storeStructs" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.notpay" :true-label="1" :false-label="0" @change="btnquery">未支付</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.back" :true-label="1" :false-label="0" @change="btnquery">金融未到账</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.ht" :true-label="1" :false-label="0" @change="btnquery">未签合同</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.tran" :true-label="1" :false-label="0" @change="btnquery">培训</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.storesale" :true-label="1" :false-label="0" @change="btnquery">店销</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.perf" :true-label="1" :false-label="0" @change="btnquery">未完成40W</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="openAddInteboSale('','')" size="mini">新增</el-button>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="inteboSaleData" v-loadmore="loadmore" style="text-align: center;" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        <div v-if="scope.row.storename">{{scope.row.parentname}}/{{scope.row.storename}}</div>
                        <div v-else>{{scope.row.parentname}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="仪器金额"  align="center" prop="totalamount"></el-table-column>
                <el-table-column label="合作模式"  align="center" prop="hzmode">
                    <template slot-scope="scope">
                        <div v-if="scope.row.hzmode==1" style="color: #409eff">全款</div>
                        <div v-if="scope.row.hzmode==2" style="color: #409eff">金融</div>
                        <div v-if="scope.row.hzmode==3" style="color: #409eff">9800</div>
                        <div v-if="scope.row.hzmode==2">
                            <div style="color: #409eff" v-if="scope.row.back==1">完成</div>
                            <div style="color: red" v-if="scope.row.back==0">未完成</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="定金/首付"  align="center"prop="sfpayment"></el-table-column>
                <el-table-column label="支付状态"  align="center"prop="paystatus">
                    <template slot-scope="scope">
                        <div style="color: #409eff" v-if="scope.row.paystatus==1">支付完成</div>
                        <div style="color: red" v-if="scope.row.paystatus==0">未支付</div>
                    </template>
                </el-table-column>
                <el-table-column label="支付日期"  align="center"prop="paydate">
                    <template slot-scope="scope">
                        <div v-if="scope.row.paydate!='1900-01-01'">{{scope.row.paydate}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="回款比率"  align="center"prop="backlv"></el-table-column>
                <el-table-column label="合同"  align="center"prop="ht" width="80">
                    <template slot-scope="scope">
                        <div style="color: #409eff" v-if="scope.row.ht==1">已签</div>
                        <div style="color: red" v-if="scope.row.ht==0">未签</div>
                    </template>
                </el-table-column>
                <el-table-column label="完成业绩"  align="center"prop="perf"></el-table-column>
                <el-table-column label="培训"  align="center"prop="bonus">
                    <template slot-scope="scope">
                        <div v-if="scope.row.trans!=null && scope.row.trans.length>0">
                            <div>{{scope.row.trans[0].headername}}</div>
                            <div>{{scope.row.trans[0].fromdate}}到{{scope.row.trans[0].todate}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="店销"  align="center"prop="bonus">
                    <template slot-scope="scope">
                        <div v-if="scope.row.salestore!=null && scope.row.salestore.length>0">
                            <div>{{scope.row.salestore[0].headername}}</div>
                            <div>{{scope.row.salestore[0].fromdate}}到{{scope.row.salestore[0].todate}}</div>
                        </div>
                    </template>
                </el-table-column>
                <!--<el-table-column label="奖励方案"  align="center"prop="bonus">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.bonus==1">已确定</el-tag>
                        <el-tag v-if="scope.row.bonus==0" type="danger">未确定</el-tag>
                    </template>
                </el-table-column>-->
                <el-table-column label="SN码"  align="center"prop="sn"></el-table-column>
                <el-table-column label="仪器型号"  align="center"prop="yqmodel"></el-table-column>
                <el-table-column label="介绍类型"  align="center"prop="jstype">
                    <template slot-scope="scope">
                        <div v-if="scope.row.jstype==1" style="color: #409eff">独立介绍人</div>
                        <div v-if="scope.row.jstype==2" style="color: #409eff">店介绍店</div>
                        <div v-if="scope.row.jstype==3" style="color: #409eff">小红书</div>
                    </template>
                </el-table-column>
                <el-table-column label="介绍人"  align="center"prop="jstor">
                    <template slot-scope="scope">
                        <div v-if="scope.row.jstorname">{{scope.row.jstorname}}</div>
                        <div v-else>{{scope.row.jstor}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="介绍费"  align="center"prop="jsamount"></el-table-column>
                <el-table-column label="操作"  align="center" width="140" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="openJs(scope.row)" type="text">介绍人</el-button>
                        <el-button @click="openAddInteboSale('show',scope.row)" type="text">查看</el-button>
                        <el-button @click="openAddInteboSale('update',scope.row)" type="text">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="门店介绍" :visible.sync="dialogVisible" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="form" :model="inteboSale" size="mini" label-width="80px" >
                <el-form-item label="单号" prop="sysbillid">
                    {{inteboSale.sysbillid}}
                </el-form-item>
                <el-form-item label="门店">
                    {{inteboSale.parentname}}/{{inteboSale.storename}}
                </el-form-item>
                <el-form-item label="介绍类型" prop="jstype">
                    <el-radio-group v-model="inteboSale.jstype">
                        <el-radio :label="1">独立介绍人</el-radio>
                        <el-radio :label="2">店介绍店</el-radio>
                        <el-radio :label="3">小红书</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="介绍人" prop="jstor">
                    <el-input v-model="inteboSale.jstor" v-if="inteboSale.jstype!=2"></el-input>
                    <el-cascader :options="storeData" clearable v-model="storeParentNameData" filterable size="mini"  style="width: 100%" @change="jsmdChange" v-else></el-cascader>
                </el-form-item>
                <el-form-item label="介绍费" prop="jsamount" v-if="inteboSale.jstype!=2">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboSale.jsamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="介绍总监" prop="jszj">
                    <el-select v-model="inteboSale.jszj" placeholder="请选择" style="width: 100%" filterable default-first-option>
                        <el-option v-for="(item,key) in zjData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="介绍费" prop="jszjamount">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboSale.jszjamount">
                    </el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="querybutton" size="mini" @click="saveInteboSaleJs()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            querybutton:false,
            zjData:[],
            storeParentNameData:[],
            inteboSale:{},
            dialogVisible:false,
            isFinite:false,
            inteboSaleData:[],
            curpage:1,
            storeData:[],
            pickerData:[],
            searchParms:{
                parentid:"",
                storeid:"",
                storeStructs:[],
                notpay:0,
                back:0,
                ht:0,
                tran:0,
                storesale:0,
                perf:0,
                sn:0,
            },
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getInteboSaleByPage();
        this.getInteboStaffByParam();
    },
    methods:{
        btnquery(){
            this.isFinite=false;
            this.inteboSaleData=[];
            this.curpage=1;
            this.getInteboSaleByPage();
        },
        getInteboSaleById(sysbillid){
            this.$post("intebosale/getInteboSaleById",{sysbillid: sysbillid}).then(res=>{
                if(res.sucess){
                    this.inteboSale=res.object;
                    let array=[];
                    let jsArray=[];
                    if(this.inteboSale.jstype==2){
                        if(this.inteboSale.jstor){
                            jsArray.push(this.inteboSale.jstorparentid);
                            jsArray.push(this.inteboSale.jstor);
                        }
                    }
                    if(this.inteboSale.storeid){
                        array.push(this.inteboSale.parentid);
                        array.push(this.inteboSale.storeid);
                    }
                    else{
                        array.push(this.inteboSale.parentid);
                    }
                    this.$nextTick(function (){
                        this.parentstoreid=array;
                        this.storeParentNameData=jsArray;
                    });
                }
            });
        },
        saveInteboSaleJs(){
            this.querybutton=true;
            this.$postw("intebosale/saveInteboSaleJs",this.inteboSale).then(res=>{
                this.querybutton=false;
                if(res.sucess){
                    this.$message({message: "请选择品牌信息", type: 'success'});
                    this.dialogVisible=false;
                    this.btnquery();
                }
            });
        },
        openJs(row){
            this.getInteboSaleById(row.sysbillid);
            //this.inteboSale=this.$copy(row);
            this.dialogVisible=true;
        },
        jsmdChange(val) {
            this.inteboSale.jstor = "";
            if (val[1]) {
                this.inteboSale.jstor = val[1];
            }
            else if (val[0]) {
                this.inteboSale.jstor = val[0];
            }
        },
        getInteboStaffByParam(){
            this.$post("inteboStaff/getInteboStaffByType",{type:1}).then(res=>{
                if(res.sucess){
                    this.zjData=res.object;
                }
            });
        },
        historyBack(){
            this.$router.push({path:'/intebotab'});
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[0]){
                this.searchParms.parentid=val[0];
            }
            if(val[1]){
                this.searchParms.storeid=val[1];
            }
            this.isFinite=false;
            this.inteboSaleData=[];
            this.curpage=1;
            this.getInteboSaleByPage();
        },
        openAddInteboSale(type,row){
            this.$router.push({path:'/addIntebosale',query:{
                    type:type,
                    sysbillid:row.sysbillid
                }});
        },
        loadmore(){
            if(this.isFinite==false){
                this.curpage++;
                this.getInteboSaleByPage();
            }
        },
        getInteboSaleByPage(){
            this.$post("intebosale/getInteboSaleByPage",{parentid:this.searchParms.parentid,
                storeid:this.searchParms.storeid,curpage:this.curpage,notpay: this.searchParms.notpay,
                back: this.searchParms.back,ht: this.searchParms.ht,tran:this.searchParms.tran,
                salestore:this.searchParms.storesale,perf:this.searchParms.perf,sn:this.searchParms.sn}).then(res=>{
                if(res.sucess){
                    let obj=res.object;
                    if(obj!=null && obj.length>0){
                        for(let val of obj){
                            this.inteboSaleData.push(val);
                        }
                    }
                    else{
                        this.isFinite=true;
                    }
                }
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
    .sale .el-input-number .el-input__inner {
        text-align: left;
    }

    .sale .van-tag{
        font-size: 20px;
    }

    // 兼容safari列头与td对不齐问题
    .el-table__header, .el-table__body, .el-table__footer{
        width:100% !important;
        table-layout: fixed !important;
    }

</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/intebosale.vue